import { configureStore } from '@reduxjs/toolkit';
import testItemReducer from './TestItemSlice.js';

const testItemStore = configureStore({
    reducer: {
        testItems: testItemReducer
    }
});

export default testItemStore;